module.exports = "<a tabindex=\"-1\"\n   class=\"mb\"\n   smb-link\n   ng-transclude\n   ng-if=\"vm.actionType === 'state'\"\n   ng-click=\"vm.pressBtn(vm)\">\n</a>\n<a tabindex=\"-1\"\n   class=\"mb\"\n   smb-link\n   ng-transclude\n   ng-if=\"vm.actionType === 'link'\"\n   ng-click=\"vm.pressBtn(vm)\">\n</a>\n<a tabindex=\"-1\"\n   class=\"mb\"\n   smb-link\n   ng-transclude\n   ng-if=\"vm.actionType === 'function'\"\n   ng-click=\"vm.pressBtn(vm)\">\n</a>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/side-menu/components/link/link.template.html
// module id = 92
// module chunks = 0